import { render, staticRenderFns } from "./TenantFeedback.vue?vue&type=template&id=cb0018f2&"
import script from "./TenantFeedback.vue?vue&type=script&lang=js&"
export * from "./TenantFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports